export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyDyX7poixuu1YP_v4hMh_EooOZtlcfmH0E',
    authDomain: 'shelcaster-ed15a.firebaseapp.com',
    databaseURL: 'https://shelcaster-ed15a-edmerson.firebaseio.com',
    projectId: 'shelcaster-ed15a',
    storageBucket: 'shelcaster-ed15a.appspot.com',
    messagingSenderId: '252586098046',
    appId: '1:252586098046:web:d827502b8a38395e82472f'
  }
};
